import { Component, Prop } from 'vue-property-decorator';
import { BaseComponent } from '@/components/base-component';
import { ImageResourceDTO } from '../../model/ImageResourceDTO';
import { getProperSize } from '../../helpers/images';

import { find } from 'lodash-es';

@Component
export class GalleryItem extends BaseComponent {
	@Prop() galleryId: string;
	@Prop() resource: ImageResourceDTO[];
	@Prop() sizes: string;
	@Prop() description: boolean;
	@Prop() height: number;
	@Prop() isLightbox: boolean;

	get fullSizeImage() {
		return getProperSize(this.resource, 1200);
	}

	get src() {
		return this.formatImageUrl(getProperSize(this.resource, 1000).path);
	}

	get srcset() {
		return this.resource.map(r => `${this.formatImageUrl(r.path)} ${r.width}w`).join(", ");
	}

	get alt() {
		let alt = find(this.resource, function (o) { return o.description != null });
		return alt ? alt.description : "";
	}

	get styles() {
		return this.height ? `height: ${this.height}px` : ''
	}
}

export default GalleryItem;
